import getAssetUrl from '@/lib/AssetService';

const markerType = {
  Available: getAssetUrl('/img/google-maps-fi/marker-enabled.png'),
  AvailableActive: getAssetUrl('/img/google-maps-fi/marker-selected.png'),
  PartlyAvailable: getAssetUrl('/img/google-maps-fi/marker-enabled.png'),
  PartlyAvailableActive: getAssetUrl('/img/google-maps-fi/marker-selected.png'),
  Neutral: getAssetUrl('/img/google-maps-fi/marker-enabled.png'),
  NeutralActive: getAssetUrl('/img/google-maps-fi/marker-selected.png'),
  Start: getAssetUrl('/img/google-maps-fi/marker-enabled.png'),
  End: getAssetUrl('/img/google-maps-fi/marker-selected.png'),
};

export function getRetailerMarkerIcon(isActive, haveArticles, isStocked) {
  let url;
  if (isActive) {
    if (haveArticles) {
      if (isStocked) {
        url = markerType.AvailableActive;
      } else {
        url = markerType.PartlyAvailableActive;
      }
    } else {
      url = markerType.NeutralActive;
    }
  } else if (haveArticles) {
    if (isStocked) {
      url = markerType.Available;
    } else {
      url = markerType.PartlyAvailable;
    }
  } else {
    url = markerType.Neutral;
  }
  return url;
}

export function getDirectionsMarkerIcon(type) {
  switch (type) {
    case 'Start':
      return markerType.Start;
    case 'End':
      return markerType.End;
    default:
      return null;
  }
}
